<template>
    <div>
        <FormPenilaianTeknis :data-view-dokumen-pengadaan="dataViewDokumenPengadaan" action="create">
        </FormPenilaianTeknis>
    </div>
    <div class="field grid" v-show="loadingApproval">
        <div class="col-12">
            <ProgressBar mode="indeterminate" style="height: .5em" />
        </div>
    </div>
</template>

<script>
import axios from 'axios'

import AppLayout from "../../../Layouts/AppLayout";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import Password from "primevue/password";
import Menubar from "primevue/menubar";
import Textarea from 'primevue/textarea';
import AppMenuBar from "../../../Components/AppMenuBar.vue";
import DropdownWilayah from "../../../Components/DropdownWilayah.vue";
import MapInput from "../../../Components/MapInput.vue";
import Calendar from 'primevue/calendar';
import { FilterMatchMode } from "primevue/api";
import { useForm } from "@inertiajs/inertia-vue3"
import Column from "primevue/column";
import Button from "primevue/button";
import Divider from "primevue/divider";
import Card from "primevue/card";
import DeleteDialog from "../../../Components/DeleteDialog";
import { Inertia } from '@inertiajs/inertia'
import MultiSelect from 'primevue/multiselect';
import Dropdown from 'primevue/dropdown';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import OverlayPanel from 'primevue/overlaypanel';
import FileUpload from 'primevue/fileupload';
import pdfvuer from 'pdfvuer'
import Dialog from 'primevue/dialog';
import ProgressBar from 'primevue/progressbar';
import AutoComplete from 'primevue/autocomplete';
import RadioButton from 'primevue/radiobutton';

import FormPenilaianTeknis from './FormPenilaianTeknis.vue';


import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";


// import PermissionTreeTable from '../../Components/PermissionTreeTable';



export default {
    setup: () => ({ vuelidate: useVuelidate() }),
    name: "Index",
    components: {
        Menubar,
        AppMenuBar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        InputText,
        Password,
        Card,
        Divider,
        MultiSelect,
        Calendar,
        DropdownWilayah,
        Dropdown,
        Accordion,
        AccordionTab,
        MapInput,
        OverlayPanel,
        FileUpload,
        pdf: pdfvuer,
        Dialog,
        ProgressBar,
        AutoComplete,
        Calendar,
        Textarea,
        RadioButton,

        FormPenilaianTeknis

    },
    props: {
        uuid: String,
        dataViewDokumenPengadaan: Object,
        errors: Object,
    },
    watch: {

    },
    data: function () {
        return {
            loadingApproval: false,
            submitted: false,
            form_approval: {
                catatan: null,
                approval: null,
            },
            form: {},

        }
    },
    validations() {
        return {
            form_approval: {
                approval: {
                    required
                }
            }
        }
    },
    methods: {
        approveForm(isFormValid) {
            this.loadingApproval = true;
            this.submitted = true;

            if (!isFormValid) {
                this.loadingApproval = false;
                return;
            }

            this.form_approval.uuid = this.uuid;

            // console.log(this.form_approval);

            axios.post('/dokumen_pengadaan/approval', this.form_approval)
                .then(response => {
                    console.log(response.data);

                    if (response.data.success) {
                        // toast success
                        this.$toast.add({ severity: 'success', summary: 'Berhasil!', detail: response.data.message, life: 3000 });
                    }

                    // emit close-dialong event
                    this.loadingApproval = false;
                    this.$emit('closemodal');
                })
                ;

            // alert('submitted');
            // alert(this.form)
            // var form_data = {
            //     formAreaLokasi : this.formAreaLokasi,
            //     formMap : this.formMap,
            //     formSertifikatBukuC : this.formSertifikatBukuC,
            //     formTandaBuktiWakaf : this.formTandaBuktiWakaf,
            //     formSuratUkur : this.formSuratUkur,
            //     formAktaIkrarWakaf : this.formAktaIkrarWakaf,
            //     formNazhir : this.formNazhir,
            //     formWakif : this.formWakif,
            //     formSaksi : this.formSaksi,
            // }
            // console.log('halo, sini');

            // console.log(JSON.stringify(this.form));
            // console.log('halo');

            // console.log(this.form);
            // alert('created act!')
            // this.$nextTick(() => {
            //     console.log(this.errors);
            // });
            // 
        },
        openPdfViewer(pdf_url) {
            var pdf_data = pdfvuer.createLoadingTask(pdf_url);
            pdf_data.then(pdf => {
                this.num_pdf_page = pdf.numPages;
                console.log(pdf.numPages);
            });
            this.displayPdfViewer = true;
        },
        closePdfViewer() {
            this.displayPdfViewer = false;
        },
    },
    mounted() {

    },
    created() {
        this.form = this.dataViewDokumenPengadaan;
    }
}
</script>

<style lang="css" scoped>
.red-radiobutton {
    border-color: #a61900;
    /* background: #a60000; */
}

.red-radiobutton.p-radiobutton-checked .p-radiobutton-box.p-highlight {
    border-color: #a61900 !important;
    background: #a60000 !important;
}
</style>